import React, { useState, useEffect, useRef } from "react";
import image1 from "../../assets/image/slide1.jpeg";
import image2 from "../../assets/image/slide2.jpeg";
import image3 from "../../assets/image/slide3.jpeg";
import image4 from "../../assets/image/slide4.jpeg";
import image5 from "../../assets/image/slide5.jpeg";
import image6 from "../../assets/image/slide6.jpeg";
import image7 from "../../assets/image/slide7.jpeg";
import image0 from "../../assets/image/slide0.jpeg";
import image9 from "../../assets/image/slide9.jpeg";
import image10 from "../../assets/image/slide10.jpeg";
import image11 from "../../assets/image/slide11.jpeg";
import image12 from "../../assets/image/slide12.jpeg";
import image13 from "../../assets/image/slide13.jpeg";
import image14 from "../../assets/image/slide14.jpeg";
import image15 from "../../assets/image/slide15.jpeg";
import image16 from "../../assets/image/slide16.jpeg";
import image17 from "../../assets/image/slide17.jpeg";
import image18 from "../../assets/image/slide18.jpeg";
import "./style.css";

const GalleryLayout = () => {
  const [selectedImage, setSelectedImage] = useState(0);
  const images = [
    { full: image1, thumb: image1 },
    { full: image2, thumb: image2 },
    { full: image3, thumb: image3 },
    { full: image4, thumb: image4 },
    { full: image5, thumb: image5 },
    { full: image6, thumb: image6 },
    { full: image7, thumb: image7 },
    { full: image0, thumb: image0 },
    { full: image9, thumb: image9 },
    { full: image10, thumb: image10 },
    { full: image11, thumb: image11 },
    { full: image12, thumb: image12 },
    { full: image13, thumb: image13 },
    { full: image14, thumb: image14 },
    { full: image15, thumb: image15 },
    { full: image16, thumb: image16 },
    { full: image17, thumb: image17 },
    { full: image18, thumb: image18 },
  ];

  const intervalRef = useRef(null); // Reference to the interval

  const startAutoSelect = () => {
    // Start the auto-select functionality
    intervalRef.current = setInterval(() => {
      setSelectedImage((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
  };

  const stopAutoSelect = () => {
    // Clear the interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  useEffect(() => {
    startAutoSelect(); // Start auto-select on component mount

    return () => stopAutoSelect(); // Cleanup on unmount
  }, [images.length]);

  const handleThumbnailClick = (index) => {
    stopAutoSelect(); // Stop auto-select
    setSelectedImage(index); // Set the clicked image
    startAutoSelect(); // Restart auto-select
  };

  return (
    <section className="gallery">
      {/* Main Image */}
      <img
        className="galleryMainImage"
        src={images[selectedImage].full}
        alt={`Main Slide ${selectedImage + 1}`}
      />

      {/* Thumbnails */}
      <div className="galleryThumbs">
        {images.map((image, index) => (
          <div
            key={index}
            className={`galleryThumb ${
              selectedImage === index ? "selected" : ""
            }`}
            onClick={() => handleThumbnailClick(index)}
          >
            <img src={image.thumb} alt={`Thumbnail ${index + 1}`} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default GalleryLayout;
